import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the SortNumPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'sortNum',
})
export class SortNumPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: number, args?: any): any {
    // return null;
    let unit = '';
    let units = ['K','M','B'];
    for(let item of units){
      if(value/1000 > 1){
        value = Math.floor(value/100)/10;
        unit = item;
      }
      else {
        break;
      }
    }
    return value + unit;
  }

}



// WEBPACK FOOTER //
// ./src/pipes/sort-num/sort-num.ts